export default __webpack_public_path__ + "static/media/f_wdt_c_5.38c51754.mp3";